var _path, _g, _g2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGemini(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "gemini__Integration=Gemini, Size=24, Dark=False",
    className: "gemini__Integration=Gemini, gemini__Size=24, gemini__Dark=False"
  }, /*#__PURE__*/React.createElement("g", {
    id: "gemini__Google_Gemini_icon_2025 2",
    className: "gemini__Google_Gemini_icon_2025 gemini__2",
    clipPath: "url(#gemini__clip0_32271_199115)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "gemini__Vector",
    fill: "#fff",
    d: "M20.617 10.834a14.135 14.135 0 0 1-4.45-3.001 14.129 14.129 0 0 1-3.68-6.452.503.503 0 0 0-.975 0 14.128 14.128 0 0 1-3.68 6.451 14.128 14.128 0 0 1-6.45 3.68.503.503 0 0 0 0 .976c.684.172 1.351.397 2.001.677 1.695.73 3.178 1.73 4.45 3.002a14.116 14.116 0 0 1 3.68 6.451.503.503 0 0 0 .975 0 13.21 13.21 0 0 1 .677-2.002 14.135 14.135 0 0 1 3.002-4.45 14.13 14.13 0 0 1 6.452-3.678.504.504 0 0 0 0-.976 13.215 13.215 0 0 1-2.002-.678Z",
    className: "gemini__Vector"
  })), /*#__PURE__*/React.createElement("g", {
    id: "gemini__Mask group",
    className: "gemini__Mask gemini__group"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "gemini__mask0_32271_199115",
    width: 22,
    height: 22,
    x: 1,
    y: 1,
    className: "gemini__mask0_32271",
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "gemini__Group",
    className: "gemini__Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "gemini__Vector_2",
    fill: "#000",
    d: "M12 1c.23 0 .431.158.488.381a14.128 14.128 0 0 0 3.68 6.451 14.135 14.135 0 0 0 6.45 3.68.503.503 0 0 1 0 .975 14.128 14.128 0 0 0-6.452 3.68 14.137 14.137 0 0 0-3 4.45c-.28.65-.506 1.317-.678 2.001a.503.503 0 0 1-.976 0 14.118 14.118 0 0 0-3.68-6.452 14.135 14.135 0 0 0-6.45-3.679.504.504 0 0 1 0-.975 14.129 14.129 0 0 0 6.452-3.68 14.128 14.128 0 0 0 3.678-6.45A.503.503 0 0 1 12 1Z",
    className: "gemini__Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "gemini__Vector_3",
    fill: "url(#gemini__paint0_linear_32271_199115)",
    d: "M12 1c.23 0 .431.158.488.381a14.128 14.128 0 0 0 3.68 6.451 14.135 14.135 0 0 0 6.45 3.68.503.503 0 0 1 0 .975 14.128 14.128 0 0 0-6.452 3.68 14.137 14.137 0 0 0-3 4.45c-.28.65-.506 1.317-.678 2.001a.503.503 0 0 1-.976 0 14.118 14.118 0 0 0-3.68-6.452 14.135 14.135 0 0 0-6.45-3.679.504.504 0 0 1 0-.975 14.129 14.129 0 0 0 6.452-3.68 14.128 14.128 0 0 0 3.678-6.45A.503.503 0 0 1 12 1Z",
    className: "gemini__Vector"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#gemini__mask0_32271_199115)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "gemini__Group_2",
    className: "gemini__Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "gemini__Group_3",
    className: "gemini__Group",
    filter: "url(#gemini__filter0_f_32271_199115)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "gemini__Vector_4",
    fill: "#FFE432",
    d: "M-.986 18.199c2.542.902 5.464-.79 6.526-3.78 1.062-2.991-.138-6.147-2.68-7.05-2.542-.903-5.463.79-6.525 3.78-1.062 2.99.137 6.147 2.68 7.05Z",
    className: "gemini__Vector"
  })), /*#__PURE__*/React.createElement("g", {
    id: "gemini__Group_4",
    className: "gemini__Group",
    filter: "url(#gemini__filter1_f_32271_199115)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "gemini__Vector_5",
    fill: "#FC413D",
    d: "M10.3 8.339c3.492 0 6.323-2.893 6.323-6.462S13.792-4.585 10.3-4.585c-3.493 0-6.323 2.893-6.323 6.462s2.83 6.462 6.323 6.462Z",
    className: "gemini__Vector"
  })), /*#__PURE__*/React.createElement("g", {
    id: "gemini__Group_5",
    className: "gemini__Group",
    filter: "url(#gemini__filter2_f_32271_199115)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "gemini__Vector_6",
    fill: "#00B95C",
    d: "M7.843 29.004c3.645-.178 6.413-4.15 6.182-8.873-.23-4.723-3.373-8.406-7.018-8.228-3.646.178-6.414 4.15-6.183 8.873.231 4.723 3.373 8.406 7.019 8.228Z",
    className: "gemini__Vector"
  })), /*#__PURE__*/React.createElement("g", {
    id: "gemini__Group_6",
    className: "gemini__Group",
    filter: "url(#gemini__filter3_f_32271_199115)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "gemini__Vector_7",
    fill: "#00B95C",
    d: "M7.843 29.004c3.645-.178 6.413-4.15 6.182-8.873-.23-4.723-3.373-8.406-7.018-8.228-3.646.178-6.414 4.15-6.183 8.873.231 4.723 3.373 8.406 7.019 8.228Z",
    className: "gemini__Vector"
  })), /*#__PURE__*/React.createElement("g", {
    id: "gemini__Group_7",
    className: "gemini__Group",
    filter: "url(#gemini__filter4_f_32271_199115)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "gemini__Vector_8",
    fill: "#00B95C",
    d: "M11.493 26.148c3.056-1.86 3.874-6.094 1.827-9.459-2.047-3.364-6.184-4.584-9.24-2.725-3.056 1.86-3.874 6.094-1.827 9.459 2.047 3.364 6.184 4.584 9.24 2.725Z",
    className: "gemini__Vector"
  })), /*#__PURE__*/React.createElement("g", {
    id: "gemini__Group_8",
    className: "gemini__Group",
    filter: "url(#gemini__filter5_f_32271_199115)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "gemini__Vector_9",
    fill: "#3186FF",
    d: "M23.846 15.575c3.436 0 6.22-2.681 6.22-5.99 0-3.307-2.784-5.988-6.22-5.988-3.434 0-6.219 2.681-6.219 5.989 0 3.307 2.785 5.989 6.22 5.989Z",
    className: "gemini__Vector"
  })), /*#__PURE__*/React.createElement("g", {
    id: "gemini__Group_9",
    className: "gemini__Group",
    filter: "url(#gemini__filter6_f_32271_199115)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "gemini__Vector_10",
    fill: "#FBBC04",
    d: "M-3.429 14.88c3.163 2.406 7.783 1.651 10.32-1.685C9.428 9.86 8.921 5.205 5.758 2.8 2.595.395-2.025 1.15-4.562 4.486-7.1 7.82-6.592 12.476-3.43 14.88Z",
    className: "gemini__Vector"
  })), /*#__PURE__*/React.createElement("g", {
    id: "gemini__Group_10",
    className: "gemini__Group",
    filter: "url(#gemini__filter7_f_32271_199115)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "gemini__Vector_11",
    fill: "#3186FF",
    d: "M12.777 18.435c3.775 2.595 8.779 1.872 11.177-1.615 2.397-3.488 1.28-8.419-2.495-11.014C17.684 3.21 12.68 3.933 10.283 7.42c-2.398 3.487-1.281 8.418 2.494 11.014Z",
    className: "gemini__Vector"
  })), /*#__PURE__*/React.createElement("g", {
    id: "gemini__Group_11",
    className: "gemini__Group",
    filter: "url(#gemini__filter8_f_32271_199115)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "gemini__Vector_12",
    fill: "#749BFF",
    d: "M19.64.208c.96 1.306-.274 3.845-2.756 5.67-2.483 1.827-5.274 2.248-6.235.943-.96-1.306.274-3.845 2.757-5.671C15.888-.676 18.68-1.098 19.64.208Z",
    className: "gemini__Vector"
  })), /*#__PURE__*/React.createElement("g", {
    id: "gemini__Group_12",
    className: "gemini__Group",
    filter: "url(#gemini__filter9_f_32271_199115)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "gemini__Vector_13",
    fill: "#FC413D",
    d: "M11.756 6.46c3.84-3.562 5.157-8.384 2.943-10.77-2.214-2.388-7.121-1.435-10.96 2.126C-.102 1.378-1.42 6.2.794 8.586c2.214 2.387 7.121 1.435 10.96-2.127Z",
    className: "gemini__Vector"
  })), /*#__PURE__*/React.createElement("g", {
    id: "gemini__Group_13",
    className: "gemini__Group",
    filter: "url(#gemini__filter10_f_32271_199115)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "gemini__Vector_14",
    fill: "#FFEE48",
    d: "M3.885 19.252c2.282 1.633 4.902 1.881 5.852.554.95-1.327-.13-3.727-2.413-5.36-2.282-1.634-4.902-1.882-5.851-.555-.95 1.327.13 3.727 2.412 5.36Z",
    className: "gemini__Vector"
  })))))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "gemini__filter0_f_32271_199115",
    width: 13.361,
    height: 14.697,
    x: -5.743,
    y: 5.435,
    className: "gemini__filter0_f_32271",
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_32271_199115",
    stdDeviation: 0.846
  })), /*#__PURE__*/React.createElement("filter", {
    id: "gemini__filter1_f_32271_199115",
    width: 28.997,
    height: 29.274,
    x: -4.199,
    y: -12.76,
    className: "gemini__filter1_f_32271",
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_32271_199115",
    stdDeviation: 4.088
  })), /*#__PURE__*/React.createElement("filter", {
    id: "gemini__filter2_f_32271_199115",
    width: 27.128,
    height: 31.014,
    x: -6.139,
    y: 4.947,
    className: "gemini__filter2_f_32271",
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_32271_199115",
    stdDeviation: 3.475
  })), /*#__PURE__*/React.createElement("filter", {
    id: "gemini__filter3_f_32271_199115",
    width: 27.128,
    height: 31.014,
    x: -6.139,
    y: 4.947,
    className: "gemini__filter3_f_32271",
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_32271_199115",
    stdDeviation: 3.475
  })), /*#__PURE__*/React.createElement("filter", {
    id: "gemini__filter4_f_32271_199115",
    width: 27.222,
    height: 27.822,
    x: -5.824,
    y: 6.145,
    className: "gemini__filter4_f_32271",
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_32271_199115",
    stdDeviation: 3.475
  })), /*#__PURE__*/React.createElement("filter", {
    id: "gemini__filter5_f_32271_199115",
    width: 25.648,
    height: 25.187,
    x: 11.023,
    y: -3.008,
    className: "gemini__filter5_f_32271",
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_32271_199115",
    stdDeviation: 3.302
  })), /*#__PURE__*/React.createElement("filter", {
    id: "gemini__filter6_f_32271_199115",
    width: 26.653,
    height: 26.864,
    x: -12.162,
    y: -4.592,
    className: "gemini__filter6_f_32271",
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_32271_199115",
    stdDeviation: 2.993
  })), /*#__PURE__*/React.createElement("filter", {
    id: "gemini__filter7_f_32271_199115",
    width: 26.887,
    height: 26.433,
    x: 3.674,
    y: -1.096,
    className: "gemini__filter7_f_32271",
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_32271_199115",
    stdDeviation: 2.673
  })), /*#__PURE__*/React.createElement("filter", {
    id: "gemini__filter8_f_32271_199115",
    width: 19.208,
    height: 17.696,
    x: 5.54,
    y: -5.334,
    className: "gemini__filter8_f_32271",
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_32271_199115",
    stdDeviation: 2.391
  })), /*#__PURE__*/React.createElement("filter", {
    id: "gemini__filter9_f_32271_199115",
    width: 24.132,
    height: 23.607,
    x: -4.319,
    y: -9.666,
    className: "gemini__filter9_f_32271",
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_32271_199115",
    stdDeviation: 2.02
  })), /*#__PURE__*/React.createElement("filter", {
    id: "gemini__filter10_f_32271_199115",
    width: 18.953,
    height: 17.621,
    x: -3.872,
    y: 8.038,
    className: "gemini__filter10_f_32271",
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_32271_199115",
    stdDeviation: 2.5
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gemini__paint0_linear_32271_199115",
    x1: 7.254,
    x2: 18.68,
    y1: 15.72,
    y2: 6.086,
    className: "gemini__paint0_linear_32271",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4893FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#4893FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.777,
    stopColor: "#969DFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BD99FE"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "gemini__clip0_32271_199115",
    className: "gemini__clip0_32271"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M1 1h22v22H1z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGemini);
export default __webpack_public_path__ + "static/media/Gemini.3329307a2d4d63bdcd02256913bf5eee.svg";
export { ForwardRef as ReactComponent };